import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { RequestContext } from "../../context/request.context";
import { MdEdit } from "react-icons/md";
import { BiCategoryAlt } from "react-icons/bi";
import UserComponent from "../addUser/addUser";
import UpdateCategory from "../category/update.category";
import roles from "../../const/roles";

export default function MyTable({ setRefresh = () => {} }) {
  const { data, request, setData } = React.useContext(RequestContext);
  const [rows, setRows] = React.useState(data["/users"] || []);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  React.useEffect(() => {
    setRows(data["/user/users?size=10000&desc=true"]);
  }, [data]);

  const updateUser = async (user) => {
    try {
      if (user.password === "") {
        delete user.password;
      }
      const data = await request(`/user/update`, "PUT", user);
      setData((prev) => {
        let index = prev["/user/users?size=10000&desc=true"].findIndex(
          (item) => item.id === data.id
        );
        prev["/user/users?size=10000&desc=true"][index] = data;
        return prev;
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  const disable = async (_id) => {
    try {
      const data = await request(`/user/disable-or-enable/${_id}`, "PATCH");
      console.log(data);
      setData((prev) => {
        let updatedUserData = data;
        const updatedUsers = prev["/user/users?size=10000&desc=true"].map((item) => {
          if (item.id === updatedUserData.id) {
            return updatedUserData;
          }
          return item;
        });
        return {
          ...prev,
          "/user/users?size=10000&desc=true": updatedUsers,
        };
      });
      setRefresh((prev) => prev + 1);
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [dialog, setDialog] = React.useState({
    open: false,
    component: null,
  });

  const handleClose = () => {
    setDialog({
      open: false,
      component: null,
    });
  };

  const columns = [
    {
      id: "name",
      label: "F.I.SH",
      minWidth: 100,
      format: (value) => {
        return value.firstName + " " + (value.lastName ?? "");
      },
    },
    {
      id: "username",
      label: "Login",
      minWidth: 100,
      format: (value) => {
        return value.username;
      },
    },
    {
      id: "role",
      label: "Roli",
      minWidth: 100,
      format: (value) => {
        const role = roles.find((r) => r.en === value.role);
        return (
          <Chip
            size="small"
            variant="outlined"
            color={value.role === "ADMIN" ? "primary" : "default"}
            label={role ? role.uz : value.role || "-"}
          />
        );
      },
    },
    {
      id: "change",
      label: "Yangilash",
      minWidth: 100,
      align: "center",
      format: (value) => {
        return (
          <IconButton
            size="small"
            onClick={() => {
              setDialog({
                open: true,
                component: (
                  <UserComponent
                    title={"Foydalanuvchini yangilash"}
                    buttonText={"Yangilash"}
                    currentUser={value}
                    action={updateUser}
                    close={handleClose}
                  />
                ),
              });
            }}
          >
            <MdEdit />
          </IconButton>
        );
      },
    },
    {
      id: "category",
      label: "Kategoriya",
      minWidth: 100,
      align: "center",
      format: (value) => {
        return (
          <IconButton
            size="small"
            onClick={() => {
              const action = async (category) => {
                try {
                  const data = await request(
                    `/user/${value.id}/update-categories`,
                    "POST",
                    category
                  );
                  setData((prev) => {
                    let index = prev["/user/users?size=10000&desc=true"].findIndex(
                      (item) => item.id === data.id
                    );
                    prev["/user/users?size=10000&desc=true"][index] = data;
                    return prev;
                  });
                  handleClose();
                } catch (error) {
                  console.log(error);
                }
              };
              setDialog({
                open: true,
                component: <UpdateCategory action={action} user={value} />,
              });
            }}
          >
            <BiCategoryAlt />
          </IconButton>
        );
      },
    },
    {
      id: "warehouses",
      label: "Omborlar",
      minWidth: 100,
      align: "center",
      // Faqat ko'rsatkich. Ilgari bu yerda alohida tanlash oynasi turardi va
      // aynan shu sababdan hech kimda ombor belgilanmay qolgan edi: tahrirlash
      // qalami bilan yonma-yon turgani bilan, uni bosish kerakligini hech kim
      // bilmasdi. Endi ombor tahrirlash oynasining ichida.
      format: (value) => {
        const count = (value.warehouses || []).length;
        return count ? (
          <Chip size="small" variant="outlined" label={`${count} ta`} />
        ) : (
          <Typography variant="caption" color="text.secondary">
            hammasi
          </Typography>
        );
      },
    },
    {
      id: "delete",
      label: "Status",
      minWidth: 50,
      align: "center",
      format: (value) => {
        return (
          <Switch
            size="small"
            color="primary"
            checked={value.enabled}
            onChange={() => {
              setDialog({
                open: true,
                component: (
                  <>
                    <DialogTitle>Ishonchingiz komilmi?</DialogTitle>
                    <DialogActions>
                      <Button onClick={handleClose}>Yo'q</Button>
                      <Button
                        onClick={async () => {
                          await disable(value.id);
                        }}
                      >
                        Ha
                      </Button>
                    </DialogActions>
                  </>
                ),
              });
            }}
          />
        );
      },
    },
  ];

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: "70vh" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(rows) &&
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                      {columns.map((column) => {
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format(row)}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100, 200, 500]}
        component="div"
        count={rows?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Qatorlar soni:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} dan ${count !== -1 ? count : `more than ${to}`}`
        }
      />
      <Dialog open={dialog.open} onClose={handleClose} fullWidth>
        {dialog.component}
      </Dialog>
    </Paper>
  );
}
